import ConfigManager from "@/config/ConfigManager";
import BzbsApi from "@/core/Http/BzbsApi";
import { DropdownListValue } from "@/helper/FormHelper";
import { DateTime } from "luxon";
import PlaceModel from "../model/PlaceModel";

export const useSearchService = function () {
    const getProvinceList = function () {
        return new Promise((resolve, reject) => {
            let url = ConfigManager.getApiModuleUrl() + "/main/province"
            BzbsApi.connectBzbsGet(url, null, null).subscribe({
                next: (resp) => {
                    let ddlBuilder = new DropdownListValue()
                    resp.data.forEach(item => {
                        ddlBuilder.add(item.province_name, item.province_code)
                    });
                    resolve(ddlBuilder.getList())
                },
                error: (err) => {
                    console.log(err)
                    reject(err)
                }
            })
        })
    }

    const getDistrict = function (provinceCode) {
        return new Promise((resolve, reject) => {
            let url = ConfigManager.getApiModuleUrl() + "/main/district"
            BzbsApi.connectBzbsGet(url, null, { province_code: provinceCode, bzbTime: DateTime.now().valueOf() }).subscribe({
                next: (resp) => {
                    let ddlBuilder = new DropdownListValue()
                    resp.data.forEach(item => {
                        ddlBuilder.add(item.district_name, item.district_code)
                    });
                    resolve(ddlBuilder.getList())
                },
                error: (err) => {
                    console.log(err)
                    reject(err)
                }
            })
        })
    }

    const getSubDistrict = function (provinceCode, districtCode) {
        return new Promise((resolve, reject) => {
            let url = ConfigManager.getApiModuleUrl() + "/main/subdistrict"
            BzbsApi.connectBzbsGet(url, null, { province_code: provinceCode, district_code: districtCode }).subscribe({
                next: (resp) => {
                    let ddlBuilder = new DropdownListValue()
                    resp.data.forEach(item => {
                        ddlBuilder.add(item.subdistrict_name, item.subdistrict_code)
                    });
                    resolve(ddlBuilder.getList())
                },
                error: (err) => {
                    console.log(err)
                    reject(err)
                }
            })
        })
    }

    const getExpert = function () {
        return new Promise((resolve, reject) => {
            let url = ConfigManager.getApiModuleUrl() + "/main/expert"
            BzbsApi.connectBzbsGet(url, null, null).subscribe({
                next: (resp) => {
                    let ddlBuilder = new DropdownListValue()
                    resp.data.forEach(item => {
                        ddlBuilder.add(item.expert_name, item.expert_code)
                    });
                    resolve(ddlBuilder.getList())
                },
                error: (err) => {
                    console.log(err)
                    reject(err)
                }
            })
        })
    }

    const searchPlaces = function (params) {
        return new Promise((resolve, reject) => {
            let url = ConfigManager.getApiModuleUrl() + "/place"
            BzbsApi.connectBzbsGet(url, null, params).subscribe({
                next: (resp) => {
                    if (resp.data) {
                        let items = []
                        for (const item of resp.data) {
                            let obj = new PlaceModel(item)
                            items.push(obj)
                        }
                        resolve(items)
                    } else {
                        resolve([])
                    }

                    resolve(resp.data)
                },
                error: (err) => {
                    console.log(err)
                    reject(err)
                }
            })
        })
    }

    return {
        getProvinceList,
        getDistrict,
        getSubDistrict,
        getExpert,
        searchPlaces
    }
}

export default useSearchService

